import { render } from "./StationBatching.vue?vue&type=template&id=3a893c4a&scoped=true"
import script from "./StationBatching.vue?vue&type=script&lang=js"
export * from "./StationBatching.vue?vue&type=script&lang=js"

import "./StationBatching.vue?vue&type=style&index=0&id=3a893c4a&scoped=true&lang=less"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a893c4a"]])

export default __exports__